import { Record } from "immutable";
import { checkDate } from "common/helpers/Date";
import { DateStringNumber } from "common/records";
import { IdType } from "common/types";

export const paymentRequestFromJSON = (data: Partial<IPaymentRequestData>): PaymentRequestRecord => {
  const record: IPaymentRequestRecord = { ...(data as any) };

  if (data.created_at) {
    record.created_at = checkDate(data.created_at);
  }

  if (data.updated_at) {
    record.updated_at = checkDate(data.updated_at);
  }

  return new PaymentRequestRecord(record);
};

export interface IPaymentRequestData {
  id: IdType;
  description: string;
  amount: string;
  to: string;
  provider: "email" | "text";
  job_id: number;
  user_id: number;
  org_id: number;
  loading?: boolean;
  sms?: string;
  emails?: string;
  kind?: "cardconnect" | "paysimple";
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IPaymentRequestRecord {
  id: string;
  description: string;
  amount: number;
  to: string;
  provider: "email" | "text";
  job_id: number;
  user_id: number;
  org_id: number;
  loading: boolean;
  sms: string;
  emails: string;
  kind?: string;
  created_at: Date;
  updated_at: Date;
}

const defaultPaymentRequestProps: IPaymentRequestRecord = {
  id: "",
  description: "",
  amount: 0,
  to: "",
  provider: "email",
  job_id: 0,
  user_id: 0,
  org_id: 0,
  loading: false,
  sms: "",
  emails: "",
  kind: "",
  created_at: new Date(),
  updated_at: new Date(),
};

export class PaymentRequestRecord extends Record(defaultPaymentRequestProps) implements IPaymentRequestRecord {}
